import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  card: {
    fontSize: '14px',
    marginBottom: theme.spacing(2.1),
    padding: `${theme.spacing(2.3)} ${theme.spacing(0.5)} ${theme.spacing(
      2.3,
    )} ${theme.spacing(2.3)}`,
  },

  topSection: {
    display: 'flex',
    alignItems: 'flex-start',
  },

  teamDataSection: {
    flex: '1 1 auto',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginLeft: theme.spacing(1.2),
  },

  teamData: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  topContent: { flex: '0 0 auto' },

  actionSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },

  checkbox: {
    float: 'right',
    margin: `0 ${theme.spacing(1.8)} 0 0`,
  },

  checkboxLabel: { fontSize: '12px' },

  label: {
    fontWeight: 500,
  },

  branchDetail: { width: '100%' },
  noPositionsText: { color: '#aaa' },
  divider: { width: '148px' },
})

export const getDeleteButtonStyles = (theme: Theme) => ({
  text: {
    color: '#005aa3',
    margin: `-${theme.spacing(1.2)} 0 -${theme.spacing(1.2)} 0`,
    padding: theme.spacing(0),
  },
})
export const getAdminCardStyles = (theme: Theme) => ({
  topSection: {
    lineHeight: '32',
    width: '100%',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    lineHeight: '30px',
    verticalAlign: 'middle',
    width: '100%',
    position: 'relative',
    paddingLeft: theme.spacing(0.4),
    fontSize: '14px',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontWeight: 400,
  },
})
